import React, { Component } from "react";
import WinnersTitle from "./winnersTitle";
import WinnersSelect from "./winnersSelect";
import WinnerBox from "./winner/winnerBox";
import WinnersAssets from "./winnersAssets";
class MainWinners extends Component {
    state = {
        winnersData: [],
        week: "Six"
    };
    handleState(e) {
        var target = e.currentTarget.value;
        console.log(target);
        this.fetchData(target);
        this.setState({
            week: target
        });
    };
    test(e){
        console.log("test")
    };
    componentDidMount() {
        this.fetchData(this.state.week)
    }
    fetchData = () => {
        fetch(`db.json`)
            .then(response => response.json())
            .then(data => this.setState({winnersData : data.filter((el) => el.week === this.state.week)}));
    };
    render() {
        const { winnersData } = this.state;
        return (
            <>

                    <WinnersTitle
                        title={"Laureaci Konkursu"}
                        subtitle={"Wybrane prace laureatów:"}
                    />
                    <div className="container">
                        <WinnersSelect onClick={e => this.handleState(e)} />
                        <div className="boxesCont">
                            {winnersData.map((data, index) => (
                                <WinnerBox
                                    key={index}
                                    linkImage={data.linkImage}
                                    prizeName={data.prizeName}
                                    classList={data.classList}
                                />
                            ))}
                        </div>
                    </div>
                    <WinnersAssets />

            </>
        );
    }
}
export default MainWinners;